import {combineReducers} from 'redux';
import data from './dataReducer';
import eventsExpressionBuilderReducer from './eventsExpressionBuilderReducer';

export default combineReducers({
  views: combineReducers({
    eventsExpressionBuilderReducer,
  }),
  data,
});
